import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Response = Api.Core.Claim.StatusRequirements.IResponse;
type Headers = Api.Core.Claim.StatusRequirements.IHeaders;
const url = '/api/Claims/Claim/StatusRequirements';
export default async function claimStatusRequirementsApi(): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
